export class VendorDashboard {
  public totalProducts: number;
  public totalCustomers: number;
  public totalEarned: number;
  public totalOrders: number;
  public labels: string[];
  public dailyOrdersCount: number[];
  public dailyOrders: number[];
}
